import type { Api } from "@/platform/api/api"
import { isUnauthorized } from "@/platform/api/errors"
import { sessionGateway, type SessionGateway } from "@/platform/api/gateways/session"
import type { BrowserSessionStatus } from "@/platform/api/session-contract"
import { inPlainAppWebView } from "@/platform/bridge/native-host-inline"

type ProbedStatus = Extract<BrowserSessionStatus, { kind: "authenticated" | "anonymous" }>

let landing: string | null | undefined

const landingAppUser = (): string | null => {
  if (typeof window === "undefined") return null
  if (landing === undefined) landing = new URLSearchParams(window.location.search).get("customerExternalId")
  return landing
}

export const forgetLandingAppUser = (): void => {
  landing = undefined
}

const foreignToApp = (userUuid: string): boolean => {
  const appUser = landingAppUser()
  return !!appUser && appUser !== userUuid && inPlainAppWebView()
}

export const statusOfProbe = (userUuid: string, sessions: Pick<SessionGateway, "revoke">): ProbedStatus => {
  if (!foreignToApp(userUuid)) return { kind: "authenticated", userUuid }
  void sessions.revoke().catch(() => {})
  return { kind: "anonymous" }
}

export const probeSession = async (api: Api, signal?: AbortSignal): Promise<ProbedStatus> => {
  const sessions = sessionGateway(api)
  try {
    const { userUuid } = await sessions.probe(signal)
    return statusOfProbe(userUuid, sessions)
  } catch (error) {
    if (isUnauthorized(error)) return { kind: "anonymous" }
    throw error
  }
}
